import { DashboardConfig } from "../../types/Execution";
import { getConfig } from "../../config/runtimeConfig";

export const baseFilePath = `assets/files/`;
export const apiBaseUrlConfig = getConfig("REACT_APP_CONFIG_API_HOST");
export const apiBaseUrlEngine = getConfig("REACT_APP_ENGINE_API_HOST");
export const apiBaseUrlPagerduty = getConfig("REACT_APP_PAGER_DUTY_HOST");

export const datatypes = ["string", "integer", "datetime", "decimal"];
export const dateTimeFormat = [
  "yyyy-mm-dd HH:MM:SS.ff",
  "yyyy-mm-ddTHH:MM:SS",
  "yyyymmdd HH:MM:SS",
  "mm/dd/yyyy",
  "mm/dd/yy",
  "dd/mm/yyyy",
  "dd/mm/yy",
  "dd-mm-yyyy",
  "dd-mm-yy",
  "mm-dd-yyyy",
  "mm-dd-yy",
  "yyyy-mm-dd",
  "yy-mm-dd",
  "m/d/yyyy",
  "m/d/yy",
  "d/m/yyyy",
  "d/m/yy",
  "m-d-yyyy",
  "m-d-yy",
  "d-m-yyyy",
  "d-m-yy",
  "bbb d, yyyy",
  "BB dd, yyyy",
  "bbb d, yy",
  "BB d, yy",
  "yyyy-mm-dd HH:MM:SS",
  "HH:MM:SS",
  "yyyy-mm-dd hh:MM:SS tt",
  "yyyy-mm-dd HH:MM:SS",
  "HH:MM",
  "hh:MM tt",
  "H:MM",
  "h:MM tt",
  "HH:MM:SS.f",
  "hh:MM:SS.f tt",
  "HH:MM:SS.f",
  "aaa bbb dd yyyy",
  "aaa, BB dd yyyy",
  "aaa, BB dd yyyy HH:MM:SS",
  "bbb dd yyyy, aaa",
  "bbb dd yyyy, aaa hh:MM tt",
  "AA, bbb dd yyyy",
  "AA, BB d yyyy h:MM tt",
  "aaa, bbb d yyyy h:MM tt",
  "yyyymmdd",
  "ddmmyyyy",
  "mmddyyyy",
  "yyyymmddhhMMSStt",
  "yyyymmddHHMMSS",
];
export const aggregationType = ["flat", "aggregated"];
export const severity_level = ["high", "medium", "low"];
export const mergeType = ["outer", "inner", "left", "right"];
export const methodType = ["get", "put", "post"];
export const ruleQueriesType = [
  "Resource",
  "External",
  "Merged_Data",
  "Missing_Data",
  "Mismatched_Data",
  "Mixed",
];
export const ruleSubQueriesType = [
  "Resource",
  "External",
  "Merged_Data",
  "Missing_Data",
  "Mismatched_Data",
];
export const genericSubQueriesType = ["Resource", "External"];
export const resourceQueriesType = ["Resource", "External"];
export const issueStatus = ["New", "In Progress", "Acknowledged", "Closed"];
export const GenericQueriesType = ["Resource", "External", "Mixed"];

export const batchReasonType = ["Missing File(s)", "Job Not Run"];
export const systemReasonType = [
  "Integration Bug",
  "Bad Translation ",
  "Defaults Not Applied",
];

export const falseReasonType = [
  "Bad Check Timing",
  "Bad Check Logic",
  "Within Tolerance",
];
export const rulesSearchType = [
  "domain_id",
  "domain_name",
  "rule_id",
  "rule_name",
  "run_id",
  "run_name",
  "from_date",
];
export const resourceSearchType = [
  "domain_id",
  "domain_name",
  "resource_id",
  "resource_name",
  "run_id",
  "run_name",
  "from_date",
];

export const contentType = [
  "application/json",
  "json",
  "application/xml",
  "xml",
];
export const sqlDatabaseType = [
  "sql",
  "mariadb",
  "azure_sql",
  "oracle_sql",
  "snowflake_sql",
  "postgres_sql",
];

export const apiType = [
  "basic_auth_api",
  "token_auth_api",
  "key_auth_api",
  "oauth_api",
  "no_auth_api",
];

export const paginatedResponseFormat = {
  items: [],
  total: 0,
  page: 0,
  size: 0,
  pages: 0,
};

export const keysToRemove = ["id", "domain_code", "code"];

//Domains
export const getDomainListUrl = `${apiBaseUrlConfig}/domains`;
export const addDomainUrl = `${apiBaseUrlConfig}/domains`;
export const getDomainDetailById = `${apiBaseUrlConfig}/domains`;
export const updateDomainById = `${apiBaseUrlConfig}/domains`;
export const cloneDomainUrl = `${apiBaseUrlConfig}/domains/clone`;
export const getDomainList = `${apiBaseUrlConfig}/domains/all/pages`;
export const getDomainBackupUrl = `${apiBaseUrlConfig}/domain-backup/pages`;
export const validateImportedDomainUrl = `${apiBaseUrlConfig}/import-entities/validate-domain`;
export const getDomainExportJsonUrl = `${apiBaseUrlConfig}/export-entities/export-domain`;
export const reactivateDomainUrl = `${apiBaseUrlConfig}/domains`;
export const validateRequestUrl = `${apiBaseUrlConfig}/validate-request/`;
export const validateRequestEngineUrl = `${apiBaseUrlEngine}/validate-request/`;
//Domains Linkage
export const getDomainLinkagePaginatedListUrl = `${apiBaseUrlConfig}/domain-linkage/all/pages`;
export const getDomainLinkageAllListUrl = `${apiBaseUrlConfig}/domain-linkage/all`;
export const addDomainLinkageUrl = `${apiBaseUrlConfig}/domain-linkage`;
export const getDomainLinkageDetailUrl = `${apiBaseUrlConfig}/domain-linkage`;
export const deleteDomainLinkageUrl = `${apiBaseUrlConfig}/domain-linkage`;
export const reactivateDomainLinkageUrl = `${apiBaseUrlConfig}/domain-linkage`;

//Resources
export const addResourceUrl = `${apiBaseUrlConfig}/resources`;
export const getResourceListByDomainId = `${apiBaseUrlConfig}/domains`;
export const getFilesByResourceId = `${apiBaseUrlConfig}/resources`;
export const validateResourceFileByFileName = `${apiBaseUrlEngine}/validations/validate`;
export const getFilesListByResourceId = `${apiBaseUrlConfig}/resources`;
export const getAllResources = `${apiBaseUrlConfig}/resources`;
export const getResourceExportJsonUrl = `${apiBaseUrlConfig}/export-entities/export-resource`;
export const addResourceColumnsUrl = `${apiBaseUrlConfig}/resources-columns`;
export const getResourceColumnsUrl = `${apiBaseUrlConfig}/resources-columns`;
export const getResourceColumnsUrlByDomain = `${apiBaseUrlConfig}/resources-columns/domain`;
export const getResourceDetailById = `${apiBaseUrlConfig}/resources`;
export const updateResourceById = `${apiBaseUrlConfig}/resources`;
export const updateResourceColumnById = `${apiBaseUrlConfig}/resources-columns`;
export const getResourceColumnsDetailById = `${apiBaseUrlConfig}/resources-columns`;
export const reactivateResourceColumnUrl = `${apiBaseUrlConfig}/resources-columns`;
export const getResourcesByIds = `${apiBaseUrlConfig}/resources`;
export const validateResource = `${apiBaseUrlEngine}/validations/validate-with-in-body-query-params`;
export const validateResourceReRun = `${apiBaseUrlEngine}/validations/rerun`;
export const backgroundValidateResource = `${apiBaseUrlEngine}/validations/validate-with-in-body-query-params-in-backgroud`;
export const backgroundValidateResourceReRun = `${apiBaseUrlEngine}/validations/rerun-in-backgroud`;
export const getValidateResourceReRun = `${apiBaseUrlConfig}/validation-results/get-latest-complete-validation-params`;
export const getResourcesList = `${apiBaseUrlConfig}/domains/resources`;
export const getResourcesColumnByDomain = `${apiBaseUrlConfig}/domains/resourceColumnDetails`;
export const cloneResourceUrl = `${apiBaseUrlConfig}/resources/clone`;
export const cloneResourceColumnUrl = `${apiBaseUrlConfig}/resources-columns/clone`;
export const getResourceBackupUrl = `${apiBaseUrlConfig}/resource-backup/pages`;
export const getResourceColumnBackupUrl = `${apiBaseUrlConfig}/resource-columns-backup/pages`;
export const validateImportedResourceUrl = `${apiBaseUrlConfig}/import-entities/validate-resource`;
export const autoGenerateDataTypesUrl = `${apiBaseUrlConfig}/autogenerate-datatypes`;
export const getValidationsCrossFieldsListByResultIdUrl = `${apiBaseUrlConfig}/validation-results/validation-cross-field-results-pages`;
export const resourcesAuthTagUrl = `${apiBaseUrlConfig}/resources/auth_tags_details`;

export const deleteResourceValidationbyIdUrl = `${apiBaseUrlEngine}/validations/delete-validation-execution-data`;
export const abortResourceValidationbyIdUrl = `${apiBaseUrlEngine}/validations/abort-validation-with-execution-id`;
export const getResourceUsedVariablesUrl = `${apiBaseUrlEngine}/validations/variables`;
export const getValidationExecutionJobStatusUrl = `${apiBaseUrlConfig}/validation-results/get-validation-execution-job-status`;

export const getValidationsErrorsListByResultIdUrlWithoutIssue = `${apiBaseUrlConfig}/validation-results/validation-error-results-pages`;
export const getValidationsErrorsListByResultIdUrl = `${apiBaseUrlConfig}/issues/validation-errors-records/pages`;
export const getValidationsDuplicateErrorsListByResultIdUrlWithoutIssue = `${apiBaseUrlConfig}/validation-results/validation-duplicate-records-pages`;
export const getValidationsDuplicateErrorsListByResultIdUrl = `${apiBaseUrlConfig}/issues/duplicate-records/pages`;
export const getValidationsNullKeysListByResultIdUrlWithoutIssue = `${apiBaseUrlConfig}/validation-results/validation-null-key-errors-pages`;
export const getValidationsNullKeysListByResultIdUrl = `${apiBaseUrlConfig}/issues/null-key-errors-records/pages`;

//Resource Column Details
export const validateImportedResourceColumnDetailUrl = `${apiBaseUrlConfig}/import-entities/validate-resource-col-details`;
export const getResourceColumnExportJsonUrl = `${apiBaseUrlConfig}/export-entities/export-resource-column-details`;
export const getResourceResultByResourceIdUrl = `${apiBaseUrlConfig}/validation-results/history/by-validation-result-id`;
export const getResourceColumnsByIds = `${apiBaseUrlConfig}/resources-columns`;
export const detectSensitiveColumnsUrl = `${apiBaseUrlConfig}/resources-columns/detecting-sensitive-columns`;
export const getValidationsParamsUrl = `${apiBaseUrlConfig}/validation-results/get-current-validation-params`;
export const getRuleParamsUrl = `${apiBaseUrlConfig}/rule-results/get-current-rule-params`;

//Rules
export const getRulesListUrl = `${apiBaseUrlConfig}/rules`;
export const addNewRule = `${apiBaseUrlConfig}/rules`;
export const executeRule = `${apiBaseUrlEngine}/rules/execute-with-in-body-query-params`;
export const executeRuleReRunUrl = `${apiBaseUrlEngine}/rules/rerun`;
export const backroundExecuteRule = `${apiBaseUrlEngine}/rules/execute-with-in-body-query-params-in-backgroud`;
export const backgroundExecuteRuleReRunUrl = `${apiBaseUrlEngine}/rules/rerun-in-backgroud`;
export const getLatestExecutionPayload = `${apiBaseUrlConfig}/rule-results/get-latest-complete-execution-params`;
export const getRulesListByDomainIdUrl = `${apiBaseUrlConfig}/domains`;
export const getExecutionRulesHistory = `${apiBaseUrlConfig}/rule-results/history/pages`;
export const getExecutionRulesHistorySummary = `${apiBaseUrlConfig}/rule-results/history/summary/pages`;
export const updateRuleById = `${apiBaseUrlConfig}/rules`;
export const getRuleDetailById = `${apiBaseUrlConfig}/rules`;
export const getDownloadRulesHistory = `${apiBaseUrlConfig}/rule-results/history/download`;
export const getDownloadExecutionsHistory = `${apiBaseUrlConfig}/validation-results/history/download`;
export const getDownloadSummaryOutput = `${apiBaseUrlEngine}/reports/summary_output/download`;
export const getDownloadDetailedOutput = `${apiBaseUrlEngine}/reports/detailed_output/download`;
export const getDownloadValidateSummaryOutput = `${apiBaseUrlEngine}/reports/validation_summary_output/download`;
export const getDownloadValidateDetailedOutput = `${apiBaseUrlEngine}/reports/validation_detailed_output/download`;
// Secure file download
export const getSecureFileDownloadUrl = `${apiBaseUrlConfig}/file-download/secure`;

export const getPaginatedRulesListUrl = `${apiBaseUrlConfig}/rules/all/pages`;
export const getRuleBackupUrl = `${apiBaseUrlConfig}/rule-backup/pages`;
export const validateImportedRuleUrl = `${apiBaseUrlConfig}/import-entities/validate-rule`;
export const getRuleExportJsonUrl = `${apiBaseUrlConfig}/export-entities/export-rule`;
export const getRuleResultByRuleIdUrl = `${apiBaseUrlConfig}/rule-results/history/by-rule-result-id`;
export const getResearchQueryDetailByRuleId = `${apiBaseUrlConfig}/comparison-research-queries/get-by-rule-id`;
export const addNewResearchQuery = `${apiBaseUrlConfig}/comparison-research-queries`;
export const updateResearchQueryById = `${apiBaseUrlConfig}/comparison-research-queries`;
export const getTableColumnsUrl = `${apiBaseUrlEngine}/utils/get-table-columns`;
export const cloneRuleUrl = `${apiBaseUrlConfig}/rules/clone`;
export const reactivateRuleUrl = `${apiBaseUrlConfig}/rules`;

export const getMissingResultByRuleResultIdUrl = `${apiBaseUrlConfig}/rule-results/missing-record-pages`;
export const getMismatchResultByRuleResultIdUrl = `${apiBaseUrlConfig}/rule-results/mismatched-record-pages`;
export const getAdhocQueryResultByRuleResultIdUrl = `${apiBaseUrlConfig}/rule-results/adhoc-query-record-pages`;
export const getResearchQueryResultByRuleResultIdUrl = `${apiBaseUrlConfig}/rule-results/research-query-record-pages`;
export const deleteRuleExecutionbyIdUrl = `${apiBaseUrlEngine}/rules/delete-comparison-execution-data`;
export const abortExecutionbyIdUrl = `${apiBaseUrlEngine}/rules/abort-rule-with-execution-id`;
export const getUsedVariablesUrl = `${apiBaseUrlEngine}/rules/variables`;
export const getRuleExecutionJobStatusUrl = `${apiBaseUrlConfig}/rule-results/get-rule-execution-job-status`;

//Linked Services
export const getLinkedServicesUrl = `${apiBaseUrlConfig}/linked-service`;
export const addLinkedServiceUrl = `${apiBaseUrlConfig}/linked-service`;
export const updateLinkedServiceById = `${apiBaseUrlConfig}/linked-service`;
export const getLinkedServiceExportJsonUrl = `${apiBaseUrlConfig}/export-entities/linked-service`;
export const getLinkedServicesBackupUrl = `${apiBaseUrlConfig}/linked-service-backup/pages`;
export const reactivateLinkedServiceUrl = `${apiBaseUrlConfig}/linked-service`;

//Connection Key
export const getConnectionKeysUrl = `${apiBaseUrlConfig}/connection-key`;
export const getAllConnectionKeysUrl = `${apiBaseUrlConfig}/connection-key/all`;
export const addConnectionKeyUrl = `${apiBaseUrlConfig}/connection-key`;
export const updateConnectionKeyById = `${apiBaseUrlConfig}/connection-key`;
export const testConnectionKeyUrl = `${apiBaseUrlConfig}/connection-key/test-connection`;
export const decryptConnectionKeyFieldUrl = `${apiBaseUrlConfig}/connection-key/decrypt`;
export const getConnectionKeyExportJsonUrl = `${apiBaseUrlConfig}/export-entities/connection-key`;
export const getConnectionKeyBackupUrl = `${apiBaseUrlConfig}/connection-key-backup/pages`;
export const reactivateConnectionKeyUrl = `${apiBaseUrlConfig}/connection-key`;

//File Processing
export const getFileProcessingUrl = `${apiBaseUrlConfig}/file-processing-attributes`;
export const addFileProcessingUrl = `${apiBaseUrlConfig}/file-processing-attributes`;
export const updateFileProcessingById = `${apiBaseUrlConfig}/file-processing-attributes`;
export const getFileProcessingAttributesExportJsonUrl = `${apiBaseUrlConfig}/export-entities/file-processing-attributes`;

//Run Instance
export const getActiveRunInstanceUrl = `${apiBaseUrlConfig}/run-instance`;
export const getRunInstanceDetailUrl = `${apiBaseUrlConfig}/run-instance`;
export const runInstanceUrl = `${apiBaseUrlConfig}/run-instance`;
export const getPaginatedRunInstanceUrl = `${apiBaseUrlConfig}/run-instance/all/pages`;
export const getRunInstanceExportJsonUrl = `${apiBaseUrlConfig}/export-entities/run-instance`;

//Execution Sub Group
export const getActiveExecutionSubGroupUrl = `${apiBaseUrlConfig}/execution-sub-group`;
export const executionSubGroupUrl = `${apiBaseUrlConfig}/execution-sub-group`;
export const getPaginatedExecutionSubGroupUrl = `${apiBaseUrlConfig}/execution-sub-group/all/pages`;
export const getExecutionSubGroupDetailUrl = `${apiBaseUrlConfig}/execution-sub-group`;

// Reports
export const getReportSummaryOutputUrl = `${apiBaseUrlEngine}/reports/summary_output`;
export const getReportDetailOutputUrl = `${apiBaseUrlEngine}/reports/detailed_output`;
export const getValidationDetailReportOutputUrl = `${apiBaseUrlEngine}/reports/validation_detailed_output`;
export const getValidationSummaryReportOutputUrl = `${apiBaseUrlEngine}/reports/validation_summary_output`;
export const getValidationRulesHistory = `${apiBaseUrlConfig}/validation-results/history/pages`;
export const getValidationHistorySummary = `${apiBaseUrlConfig}/validation-results/history/summary/pages`;

// auth
export const loginUrl = `${apiBaseUrlConfig}/basic-auth/token`;
export const logoutUrl = `${apiBaseUrlConfig}/basic-auth/logout`;
export const signupUrl = `${apiBaseUrlConfig}/basic-auth/signup`;
export const refreshTokenUrl = `${apiBaseUrlConfig}/basic-auth/refresh-token`;
export const sendOtpUrl = `${apiBaseUrlConfig}/basic-auth/send-otp`;
export const verifyOtpUrl = `${apiBaseUrlConfig}/basic-auth/verify-otp`;
export const resetPasswordUrl = `${apiBaseUrlConfig}/basic-auth/reset-password`;

// users
export const getUserProfileUrl = `${apiBaseUrlConfig}/users/profile`;
export const getMyProfile = `${apiBaseUrlConfig}/user/my-profile`;
export const changePasswordUrl = `${apiBaseUrlConfig}/user/change-password`;

//user-role
export const getUserRoleUrl = `${apiBaseUrlConfig}/user-role`;

//system
export const getSystemUrl = `${apiBaseUrlConfig}/system`;

//auth-tag
export const getAuthTagUrl = `${apiBaseUrlConfig}/auth-tag`;

//user
export const getUserUrl = `${apiBaseUrlConfig}/user`;

//user-group-users
export const getUserGroupUsersUrl = `${apiBaseUrlConfig}/user-group-users`;

export const assignUserToGroupUrl = `${apiBaseUrlConfig}/user-group-users/update-users`;

// Role Management URLs
export const getRolesListUrl = `${apiBaseUrlConfig}/user-role`;
export const getPaginatedRolesListUrl = `${apiBaseUrlConfig}/user-role/all/pages`;
export const createRoleUrl = `${apiBaseUrlConfig}/user-role`;
export const updateRoleUrl = `${apiBaseUrlConfig}/user-role`;
export const deleteRoleUrl = `${apiBaseUrlConfig}/user-role`;

//users list
// export const getUsersListUrl = `${apiBaseUrlConfig}/users`;
export const getUsersListUrl = `${apiBaseUrlConfig}/user`;

// Group Management URLs
export const getUserGroupUrl = `${apiBaseUrlConfig}/user-group`;
export const getUserGroupRolesUrl = `${apiBaseUrlConfig}/user-group-roles/user-group`;
export const getUserGroupAuthTagsUrl = `${apiBaseUrlConfig}/user-group-auth-tags/user-group`;
export const getPaginatedGroupsListUrl = `${apiBaseUrlConfig}/user-group/all/pages`;
export const createGroupUrl = `${apiBaseUrlConfig}/user-group`;
export const updateGroupUrl = `${apiBaseUrlConfig}/user-group`;
export const deleteGroupUrl = `${apiBaseUrlConfig}/user-group`;

// AuthTag Management URLs
export const getUserAuthTagUrl = `${apiBaseUrlConfig}/auth-tag`;
export const getActiveAuthTagUrl = `${apiBaseUrlConfig}/auth-tag`;
export const getPaginatedAuthTagsListUrl = `${apiBaseUrlConfig}/auth-tag/all/pages`;
export const createAuthTagUrl = `${apiBaseUrlConfig}/auth-tag`;
export const updateAuthTagUrl = `${apiBaseUrlConfig}/auth-tag`;
export const deleteAuthTagUrl = `${apiBaseUrlConfig}/auth-tag`;

// User Assignment URLs
export const getUserRolesUrl = `${apiBaseUrlConfig}/user-user-roles/user`;
export const getUserAuthTagsUrl = `${apiBaseUrlConfig}/user-auth-tags/user`;
export const getUserSystemsUrl = `${apiBaseUrlConfig}/user-systems/user`;

//get incident
export const getResolveIncidentByIdUrl = `${apiBaseUrlConfig}/incidents/update`;
export const getIncidentByExecutionIdsUrl = `${apiBaseUrlConfig}/incidents`;
export const postIncidentCommentsUrl = `${apiBaseUrlConfig}/incidents/update/post-comment`;

// File listing utilities
export const getBlobListsUrl = `${apiBaseUrlEngine}/utils/listblobs`;
export const getSftpListsUrl = `${apiBaseUrlEngine}/utils/listsftp`;

//Issue Management
export const getIssuesDetailURl = `${apiBaseUrlConfig}/issues`;
export const getExecutionIssuesDetailPaginatedURl = `${apiBaseUrlConfig}/issues/pages`;

export const getIssuesHistoryURl = `${apiBaseUrlConfig}/issues/history`;
export const getMismatchRecordsWithIssuesByExecutionIdUrl = `${apiBaseUrlConfig}/issues/mismatched-records`;
export const getMismatchRecordsWithSnapshotsByExecutionIdUrl = `${apiBaseUrlConfig}/rule-results/mismatched-record-pages`;
export const getMissingRecordsWithIssuesByExecutionIdUrl = `${apiBaseUrlConfig}/issues/missing-records`;
export const getMissingRecordsWithSnapshotsByExecutionIdUrl = `${apiBaseUrlConfig}/rule-results/missing-record-pages`;

//Research Issues Management
export const getResearchIssuesDetailPaginatedURl = `${apiBaseUrlConfig}/research-issues/rule-research-issues/pages`;
export const getResearchIssuesDetailWithoutIssuesPaginatedURl = `${apiBaseUrlConfig}/rule-results/research-query-record-pages`;
export const getRuleResearchIssuesHistoryURl = `${apiBaseUrlConfig}/research-issues/history`;
export const updateRuleResearchIssueURl = `${apiBaseUrlConfig}/research-issues`;
export const massUpdateRuleResearchIssuesURl = `${apiBaseUrlConfig}/research-issues/mass_update/`;

//Issue Manement for Validation

export const getValidationIssuesDetailURl = `${apiBaseUrlConfig}/issues/validation`;
export const getValidationIssuesHistoryURl = `${apiBaseUrlConfig}/issues/validation/history`;
export const getValidationIssuesDetailPaginatedURl = `${apiBaseUrlConfig}/issues/pages/validation`;

// generic research queries
export const getGenericResearchQueriesList = `${apiBaseUrlConfig}/generic-research-queries/all`;
export const getGenericResearchQueryURL = `${apiBaseUrlConfig}/generic-research-queries`;
export const getGenericResearchQueryDetailByIdURL = `${apiBaseUrlConfig}/generic-research-queries`;
export const cloneGenericResearchQueryUrl = `${apiBaseUrlConfig}/generic-research-queries/clone`;
export const getGenericResearchQueryBackupUrl = `${apiBaseUrlConfig}/generic-research-queries-backup/pages`;
export const executeResearchQueryURL = `${apiBaseUrlEngine}/generic-research-queries/execute`;
export const backgroundExecuteResearchQueryURL = `${apiBaseUrlEngine}/generic-research-queries/execute_in_background`;
export const backgroundExecuteResearchQueryReRunURL = `${apiBaseUrlEngine}/generic-research-queries/rerun_in_background`;
export const getResearchQueryHistoryURL = `${apiBaseUrlConfig}/generic-research-query-results`;
export const getResearchQueryHistorySummaryURL = `${apiBaseUrlConfig}/generic-research-query-results/summary/pages`;
export const getResearchQueryByExecutionIdUrl = `${apiBaseUrlConfig}/generic-research-query-results`;
export const deleteResearchQueryByResearchQueryIdUrl = `${apiBaseUrlConfig}/generic-research-queries`;
export const deleteExecutionResultByExecutionIdUrl = `${apiBaseUrlEngine}/generic-research-queries`;
export const abortResearchQueryExecutionbyIdUrl = `${apiBaseUrlEngine}/generic-research-queries/abort-generic-research-query-with-execution-id`;
export const executeReRunResearchQueryURL = `${apiBaseUrlEngine}/generic-research-queries/rerun`;
export const getResearchQueryRerunData = `${apiBaseUrlConfig}/generic-research-query-results/get-latest-complete-execution-params`;
export const getResearchQueryRerunParams = `${apiBaseUrlConfig}/generic-research-query-results/get-current-complete-execution-params`;

export const getRuleResearchIssuesDetailPaginatedURl = `${apiBaseUrlConfig}/research-issues/rule-research-issues/pages`;
export const getGenericIssuesDetailPaginatedURl = `${apiBaseUrlConfig}/research-issues/generic-query-issues/pages`;
// export const getGenericResearchIssuesHistoryURl = `${apiBaseUrlConfig}/research-issues/generic-query-issues/history`;
export const getGenericResearchQueryExportJsonUrl = `${apiBaseUrlConfig}/export-entities/export-generic-research-query`;
export const validateImportedGenericResearchQueryUrl = `${apiBaseUrlConfig}/import-entities/validate-generic-research-query`;
export const reactivateGenericResearchQueryUrl = `${apiBaseUrlConfig}/generic-research-queries`;
export const getAllSystemUrl = `${apiBaseUrlConfig}/system`;
export const newSystemUrl = `${apiBaseUrlConfig}/system`;

//classification
export const issueClassificationUrl = `${apiBaseUrlConfig}/issue-classification`;

//reason
export const issueReasonUrl = `${apiBaseUrlConfig}/issue-reason`;

// Generic Research Issues Management
export const getGenericResearchIssuesDetailPaginatedURl = `${apiBaseUrlConfig}/research-issues/generic-research-query-issues/pages`;
export const getGenericResearchIssuesDetailWithoutIssuesPaginatedURl = `${apiBaseUrlConfig}/generic-research-query-results`;

// Casbin Policy Management URLs
export const getCasbinPoliciesUrl = `${apiBaseUrlConfig}/casbin-policy/policies`;
export const bulkUpdateCasbinPoliciesUrl = `${apiBaseUrlConfig}/casbin-policy/bulk/policies`;

// Connection Runtime Config
export const getConnectionRuntimeConfigUrl = `${apiBaseUrlConfig}/connection-runtime-config/all/pages`;
export const addConnectionRuntimeConfigUrl = `${apiBaseUrlConfig}/connection-runtime-config`;

// comparison research queries
export const getComparisonResearchQueriesListUrl = `${apiBaseUrlConfig}/comparison-research-queries/all`;
export const getComparisonResearchQueryConfigUrl = `${apiBaseUrlConfig}/comparison-research-queries/all/pages`;
export const getComparisonResearchQueryBackupUrl = `${apiBaseUrlConfig}/comparison-research-queries-backup/pages`;
export const getComparisonResearchQueryByIdUrl = `${apiBaseUrlConfig}/comparison-research-queries`;
export const getComparisonResearchQueryExportJsonUrl = `${apiBaseUrlConfig}/export-entities/export-comparison-research-query`;
export const validateImportedComparisonResearchQueryUrl = `${apiBaseUrlConfig}/import-entities/validate-comparison-research-query`;
export const getAllComparisonResearchQueriesUrl = `${apiBaseUrlConfig}/comparison-research-queries/all`;
export const assignResearchQueryToRuleUrl = `${apiBaseUrlConfig}/comparison-research-queries/assign-unassign-rule-id`;
export const reactivateComparisonResearchQueryUrl = `${apiBaseUrlConfig}/comparison-research-queries`;
export const cloneComparisonResearchQueryUrl = `${apiBaseUrlConfig}/comparison-research-queries/clone`;

// Dashboard configurations
export const DASHBOARDS: DashboardConfig[] = [
  {
    id: "dashboard-1",
    label: "Validation Overview",
    path: "/validation-overview/validation-overview-dashboard?orgId=1&from=now-1h&to=now&timezone=browser&var-execution_id=$__all&var-rule_id=$__all&refresh=5s",
  },
  {
    id: "dashboard-2",
    label: "Validation Performance",
    path: "/validation-performance/datatool-validation-performance?orgId=1&from=now-30m&to=now&timezone=browser&var-execution_id=$__all&refresh=5s",
  },
  {
    id: "dashboard-3",
    label: "Comparison Overview",
    path: "/datatool-comparison-overview/comparison-overview-dashboard?orgId=1&from=now-1h&to=now&timezone=browser&var-execution_id=&var-rule_id=&refresh=5s",
  },
  {
    id: "dashboard-4",
    label: "Comparison Performance",
    path: "/rule-performance/datatool-comparison-performance?orgId=1&from=now-30m&to=now&timezone=browser&var-execution_id=$__all&refresh=5s",
  },

  {
    id: "dashboard-5",
    label: "Database Health and Performance",
    path: "/datatool-db-health-performance/datatool-database-health-and-performance?orgId=1&from=now-30m&to=now&timezone=browser&var-database=$__all&refresh=5s",
  },
];
//execution checkpoints
export const executionCheckPointsUrl = `${apiBaseUrlConfig}/execution-checkpoints/by-execution-id`;

// ─── Scoring ───

// Validation Scoring Config (BE)
export const getValidationScoringConfigUrl = `${apiBaseUrlConfig}/validation-scoring-config`;
export const getValidationScoringConfigDefaultsUrl = `${apiBaseUrlConfig}/validation-scoring-config/defaults`;
export const getPaginatedValidationScoringConfigUrl = `${apiBaseUrlConfig}/validation-scoring-config/all/pages`;
export const getValidationScoringConfigBackupUrl = `${apiBaseUrlConfig}/validation-scoring-config-backup`;

// Comparison Scoring Config (BE)
export const getComparisonScoringConfigUrl = `${apiBaseUrlConfig}/comparison-scoring-config`;
export const getComparisonScoringConfigDefaultsUrl = `${apiBaseUrlConfig}/comparison-scoring-config/defaults`;
export const getPaginatedComparisonScoringConfigUrl = `${apiBaseUrlConfig}/comparison-scoring-config/all/pages`;
export const getComparisonScoringConfigBackupUrl = `${apiBaseUrlConfig}/comparison-scoring-config-backup`;

// Run Scoring Config (BE)
export const getRunScoringConfigUrl = `${apiBaseUrlConfig}/run-scoring-config`;
export const getPaginatedRunScoringConfigUrl = `${apiBaseUrlConfig}/run-scoring-config/all/pages`;
export const batchRunScoringConfigUrl = `${apiBaseUrlConfig}/run-scoring-config/batch`;

// Generic RQ Scoring Config (BE)
export const getGenericRQScoringConfigUrl = `${apiBaseUrlConfig}/research-query-scoring-config`;
export const getPaginatedGenericRQScoringConfigUrl = `${apiBaseUrlConfig}/research-query-scoring-config/all/pages`;
export const getGenericRQScoringConfigBackupUrl = `${apiBaseUrlConfig}/research-query-scoring-config-backup`;

// Score Results (BE)
export const getValidationScoreUrl = `${apiBaseUrlConfig}/scores/validation`;
export const getValidationScoreByResourceUrl = `${apiBaseUrlConfig}/scores/validation/resource`;
export const getComparisonScoreUrl = `${apiBaseUrlConfig}/scores/comparison`;
export const getComparisonScoreByRuleUrl = `${apiBaseUrlConfig}/scores/comparison/rule`;
export const getRunScoreUrl = `${apiBaseUrlEngine}/scores/run`;
export const getGenericRQScoreUrl = `${apiBaseUrlConfig}/scores/research-query`;
// export const getGenericRQScoreUrl = `${apiBaseUrlConfig}/scores/generic-rq`;
export const getGenericRQScoreHistoryUrl = `${apiBaseUrlConfig}/scores/research-query/history/pages`;

// Recalculation (BE → EE)
export const recalculateValidationScoreUrl = `${apiBaseUrlEngine}/scoring/validate`;
export const recalculateComparisonScoreUrl = `${apiBaseUrlEngine}/scoring/compare`;
export const recalculateRunScoreUrl = `${apiBaseUrlEngine}/scoring/run`;
export const recalculateGenericRQScoreUrl = `${apiBaseUrlEngine}/scoring/research-query`;

// Severity options for dropdowns
export const scoringSeverityOptions = ["low", "medium", "high"];

// Custom factor target options
export const customFactorTargetOptions = [
  "missing",
  "mismatch_low",
  "mismatch_medium",
  "mismatch_high",
];

// Default config values (matching BE /defaults endpoint)
export const validationScoringConfigDefaults = {
  impact_of_record_level: 0.5,
  impact_of_issue_level: 0.5,
  factor_low: 0.25,
  factor_medium: 0.5,
  factor_high: 1.0,
};

export const comparisonScoringConfigDefaults = {
  blend_ratio: 1.0,
  category_weight_missing: 0.7,
  category_weight_mismatch: 0.2,
  category_weight_validation: 0.1,
  missing_factor: 3.0,
  mismatch_factor_low: 0.25,
  mismatch_factor_medium: 0.5,
  mismatch_factor_high: 1.0,
};

// Generic RQ scoring uses the same formula & field names as validation scoring,
// but with its own SCORING_GRQ_* environment variables on the backend.
export const genericRQScoringConfigDefaults = {
  impact_of_record_level: 0.5,
  impact_of_issue_level: 0.5,
  factor_low: 0.25,
  factor_medium: 0.5,
  factor_high: 1.0,
};

// ─── Validation Run Scoring Config (per-run, per-resource override) ───
export const getValidationRunScoringConfigUrl = `${apiBaseUrlConfig}/validation-run-scoring-config`;
export const getPaginatedValidationRunScoringConfigUrl = `${apiBaseUrlConfig}/validation-run-scoring-config/all/pages`;
export const getValidationRunScoringConfigDefaultsUrl = `${apiBaseUrlConfig}/validation-run-scoring-config/defaults`;
export const getValidationRunScoringConfigBackupUrl = `${apiBaseUrlConfig}/validation-run-scoring-config-backup`;

// ─── Comparison Run Scoring Config (per-run, per-rule override) ───
export const getComparisonRunScoringConfigUrl = `${apiBaseUrlConfig}/comparison-run-scoring-config`;
export const getPaginatedComparisonRunScoringConfigUrl = `${apiBaseUrlConfig}/comparison-run-scoring-config/all/pages`;
export const getComparisonRunScoringConfigDefaultsUrl = `${apiBaseUrlConfig}/comparison-run-scoring-config/defaults`;
export const batchComparisonRunScoringConfigUrl = `${apiBaseUrlConfig}/comparison-run-scoring-config/batch`;

// ─── Research Query Run Scoring Config (per-run, per-GRQ override) ───
export const getResearchQueryRunScoringConfigUrl = `${apiBaseUrlConfig}/research-query-run-scoring-config`;
export const getPaginatedResearchQueryRunScoringConfigUrl = `${apiBaseUrlConfig}/research-query-run-scoring-config/all/pages`;
export const getResearchQueryRunScoringConfigDefaultsUrl = `${apiBaseUrlConfig}/research-query-run-scoring-config/defaults`;
export const batchResearchQueryRunScoringConfigUrl = `${apiBaseUrlConfig}/research-query-run-scoring-config/batch`;

// ─── Run Scoring Pipeline Weight Config ───
export const getRunScoringPipelineWeightConfigUrl = `${apiBaseUrlConfig}/run-scoring-pipeline-weight-config`;
export const getPaginatedRunScoringPipelineWeightConfigUrl = `${apiBaseUrlConfig}/run-scoring-pipeline-weight-config/all/pages`;
export const getRunScoringPipelineWeightConfigDefaultsUrl = `${apiBaseUrlConfig}/run-scoring-pipeline-weight-config/defaults`;

// ─── Aggregated Run Score ───
// GET: dashboard fetch + history listing are served by the Config service
export const getAggregatedRunScoreUrl = `${apiBaseUrlConfig}/scores/run`;
// POST: score recalculation is served by the Engine service
export const generateAggregatedRunScoreUrl = `${apiBaseUrlEngine}/scoring/run`;

// Valid pipeline types for weight config
export const validPipelineTypes = [
  "comparison",
  "validation",
  "research_query",
];

// Default values for new configs
export const validationRunScoringConfigDefaults = {
  severity: "medium",
  factor: 1.0,
};

export const comparisonRunScoringConfigDefaults = {
  severity: "medium",
  factor: 1.0,
};

export const researchQueryRunScoringConfigDefaults = {
  severity: "medium",
  factor: 1.0,
};

export const pipelineWeightConfigDefaults = {
  comparison_weight: 1.0,
  validation_weight: 1.0,
  research_query_weight: 1.0,
};
